import React from 'react';
import { useSelector } from 'react-redux';

import colors from '@theme/colors';
import { Text } from '@utils';
import Link from '@components/i18n/Link';
import { getLocalizedContent as l } from '@helpers/languages';
import ComposableMarkup from '@utils/ComposableMarkup';
import content from './404.json';
import StyledAsset from './styles';

const LinkWrapper = ({ to, children }) => <Link to={to}>{children}</Link>;

const NotFound = () => {
  const { language } = useSelector(({ appState }) => appState);
  const { isProfileFetched } = useSelector(({ userProfile }) => userProfile);

  return (
    <StyledAsset.Wrap>
      <StyledAsset.Video
        frameborder="0"
        allow="autoplay; fullscreen"
        allowfullscreen
        src="//player.vimeo.com/video/402991018?background=1&autoplay=1"
      />

      <StyledAsset.HeaderWrap>
        <Text
          component="h2"
          variant="H2"
          mobileVariant="24"
          color={colors.white}
        >
          {l(content.unplugged, language)}
        </Text>
      </StyledAsset.HeaderWrap>
      <StyledAsset.TextWrap>
        <ComposableMarkup
          container="span"
          components={{
            link: {
              type: LinkWrapper,
              props: { to: isProfileFetched ? '/portal/account' : '/' },
            },
          }}
        >
          {isProfileFetched
            ? l(content.checkYourAccount, language)
            : l(content.checkOurHomepage, language)}
        </ComposableMarkup>
      </StyledAsset.TextWrap>
    </StyledAsset.Wrap>
  );
};

export default NotFound;
